import { useState } from 'react';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import { useDispatch } from 'react-redux';
import { setItemMasterHelpStatus } from '../utility/Redux/modal';
import ItemMasterHelp from './iteemMasterHelp';



export function RfidCodeMasterForm({ onClose, onSuccess, prefix, token }) {
  const [formData, setFormData] = useState({
    icode: '',
    itemname: '',
    from_epc: '',
    to_epc: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      CallAPIPromise('api/rfidCodeMaster/saveRfidCodeMaster', {
        ...formData,
        table_prefix: prefix
      }, token).then(() => {
        setMessage({ type: 'success', text: 'RFID code saved successfully!' });

        setTimeout(() => {
          setMessage(null);
          setFormData({
            icode: '',
            itemname: '',
            from_epc: '',
            to_epc: '',
          });
          onSuccess();
          onClose();
        }, 2000);

      }).catch(() => {
        setMessage({
          type: 'error',
          text: 'An error occurred'
        });
        setTimeout(() => {
          setMessage(null);
        }, 5000);
      }).finally(() => {
        setLoading(false);
      });
    } catch (error) {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
const dispatch = useDispatch()
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-6">
          <h2>Create RFID Code</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="space-y-2">
                      <div className='flex'>
                      <label htmlFor="icode" className="block text-sm text-gray-700">
              Item Code
                          </label>
                          <button onClick={() => {
                              dispatch(setItemMasterHelpStatus(true))
                          }}>
                              <i className='bi bi-search ml-2 text-orange'/>
                          </button>
                      </div>
           
            <input
              type="text"
              id="icode"
              name="icode"
              value={formData.icode}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter item code"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="itemname" className="block text-sm text-gray-700">
              Item Name
            </label>
            <input
              type="text"
              id="itemname"
              name="itemname"
              value={formData.itemname}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter item name"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label htmlFor="from_epc" className="block text-sm text-gray-700">
                From EPC
              </label>
              <input
                type="text"
                id="from_epc"
                name="from_epc"
                value={formData.from_epc}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Start EPC code"
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="to_epc" className="block text-sm text-gray-700">
                To EPC
              </label>
              <input
                type="text"
                id="to_epc"
                name="to_epc"
                value={formData.to_epc}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="End EPC code"
              />
            </div>
          </div>

          {message && (
            <div
              className={`p-4 rounded-md ${
                message.type === 'success'
                  ? 'bg-green-50 text-green-800 border border-green-200'
                  : 'bg-red-50 text-red-800 border border-red-200'
              }`}
            >
              {message.text}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-3 px-4 rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? 'Saving...' : 'Save RFID Code'}
          </button>
        </form>
          </div>
          <ItemMasterHelp onRowClick={(p) => {
              dispatch(setItemMasterHelpStatus(false))
              setFormData({
                  ...formData,
                  icode: p.row.ICODE,
                  itemname:p.row.ITEMNAME
              })
          }} />
    </div>
  );
}
